import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'


import StripeOrderInvoices from './components/StripeOrderInvoices.vue'
declareVconsoleComponent('stripeOrderInvoices', StripeOrderInvoices, 'stripe:orders:user:invoices')